import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaDivergenciaProva(props) {
    const { estrutura } = props;
    const { divergencias } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "divergencias",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Título Prova',
                    accessor: 'titulo_prova',
                },
                {
                    Header: 'Divergência Turma 1',
                    accessor: 'somente_turma_1',
                },
                {
                    Header: 'Divergência Turma 2',
                    accessor: 'somente_turma_2',
                },
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={divergencias}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaDivergenciaProva;
